import { ref, computed } from '@vue/composition-api'
import store from '@/store'

export default function useVerticalNavMenu(props) {
  // ------------------------------------------------
  // isVerticalMenuCollapsed
  // ------------------------------------------------
  const isVerticalMenuCollapsed = computed({
    get: () => store.state.verticalMenu.isVerticalMenuCollapsed,
    set: val => {
      store.commit('verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED', val)
    },
  })

  const isShowChild = computed({
    get: () => store.state.verticalMenu.isShowChild,
  })

  const childrenMenu = computed({
    get: () => store.state.verticalMenu.childrenMenu,
  })

  const rootRoute = computed({
    get: () => store.state.verticalMenu.rootRoute,
    set: val => {
      store.commit('verticalMenu/UPDATE_ROOT_ROUTE', val)
    },
  })

  // ------------------------------------------------
  // collapseTogglerIcon
  // ------------------------------------------------
  const collapseTogglerIcon = computed(() => {
    if (props.isVerticalMenuActive) {
      return isVerticalMenuCollapsed.value ? 'unpinned' : 'pinned'
    }
    return 'close'
  })

  const isMouseHovered = ref(false)

  const updateMouseHovered = val => {
    isMouseHovered.value = val
  }
  const updateMouseHoveredSec = val => {
    if (!val) {
      store.commit('verticalMenu/UPDATE_CHILDREN_SHOW', false)
    }
  }

  const toggleCollapsed = () => {
    isVerticalMenuCollapsed.value = !isVerticalMenuCollapsed.value
  }

  return {
    isMouseHovered,
    isVerticalMenuCollapsed,
    collapseTogglerIcon,
    toggleCollapsed,
    updateMouseHovered,
    updateMouseHoveredSec,
    childrenMenu,
    isShowChild,
    rootRoute,
  }
}
